import ImportController from '../controllers/ImportController';
import AddZmCollectionAssets from '../queries/lightbox/assets/AddZmCollectionAssets';
const debug = require('../debug/debug')('wc:protocol:CollectionUploadOperation');

export default class CollectionUploadOperation {
  constructor(uploadings, collectionId, collectionName, autoSubmit) {
    this._uploadComplete = false;
    this._submitted = autoSubmit;
    this._canceled = false;
    this._successfulUploads = [];
    this._uploadCount = 0;
    this._successfulUploadCount = 0;
    this._unsuccessfulUploadCount = 0;
    this._timerCount = 0;
    this.timer = null;
    this.importPromise = null;
    this.addToCollectionPromise = null;
    this.uploadings = uploadings;
    this.uniqueKey = uploadings[0].uniqueKey;
    this.collectionId = collectionId;
    this.collectionName = collectionName;
    this.uploadPromises = [this.runUploadTask(uploadings)];
  }

  runUploadTask(uploadings) {
    debug('[runUploadTask()] Begin');
    if (this._canceled) {
      debug('[runUploadTask()] Canceled');
      return;
    }

    this._uploadCount++;
    return ImportController.getInstance()
      .watchUploadings(this, uploadings)
      .then((successfulUploads) => {
        debug('[runUploadTask()] Success');
        ImportController.getInstance().resetUniqueKey();
        this._successfulUploads = this._successfulUploads.concat(successfulUploads);
        this._successfulUploadCount++;
        if (this._submitted && this.addUploadsComplete()) {
          this.runImportTask();
        }
      })
      .catch((err) => {
        logger.error('[runUploadTask()] error: ', err);
        this._unsuccessfulUploadCount++;
        if (this._submitted && this.addUploadsComplete()) {
          this.runImportTask();
        }
      });
  }

  runImportTask() {
    debug('[runImportTask()] Begin');
    if (this._canceled) {
      debug('[runImportTask()] Canceled');
      return;
    }

    this._processing = true;
    this.importPromise = ImportController.getInstance().issueImportQuery(this._successfulUploads, this.uniqueKey);
    this.importPromise
      .then((res) => {
        debug('[runImportTask()] Success');
        return this.runAddToCollectionTask(res);
      })
      .catch((errorDetails) => {
        logger.error('[runImportTask()] Error: ', errorDetails);
        window.setError(errorDetails.toString());

        // Should we remove the operation here?
        return ImportController.getInstance().removeCollectionUploadOperation(this);
      });

    return this.importPromise;
  }

  runAddToCollectionTask(importQueryResponse) {
    debug('[runAddToCollectionTask()] Begin');
    this.addToCollectionPromise = new AddZmCollectionAssets(this.collectionId, [], importQueryResponse).run();
    this.addToCollectionPromise.then(
      () => {
        debug('[runAddToCollectionTask()] Success');
        this._processing = false;
        return ImportController.getInstance().removeCollectionUploadOperation(this);
      },
      (errorDetails) => {
        this._processing = false;
        window.setError(errorDetails.toString());
        return ImportController.getInstance().removeCollectionUploadOperation(this);
      }
    );

    return this.addToCollectionPromise;
  }

  submit() {
    if (this._submitted) {
      return;
    }

    this._submitted = true;
    if (this.addUploadsComplete()) {
      this.runImportTask();
    }
  }

  cancel() {
    this.uploadings.forEach((u) => u.abort());
    this._canceled = true;
    ImportController.getInstance().removeCollectionUploadOperation(this);
  }

  removeUploading(uploading) {
    this.uploadings = this.uploadings.filter((u) => u.id !== uploading.id);
  }

  addUploadTask(uploadings) {
    this.uploadings = this.uploadings.concat(uploadings);
    this.uploadPromises.push(this.runUploadTask(uploadings));
  }

  addUploadsComplete() {
    return this._uploadCount === this._successfulUploadCount + this._unsuccessfulUploadCount;
  }

  getUploadCount() {
    return this.uploadings.length;
  }
}
